export default "__VITE_ASSET__5LiV4UkI__"